  import { CartLinesUpdateEvent } from '@shopify/events';

  if (!window.__albCartIntegration) {
    window.__albCartIntegration = true;

    (function () {
      var CART_ADD = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';
      var CART_URL = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      var CART_JSON_SECTION = 'alb-cart-json';
      var PENDING_TEXT = 'Wird hinzugefügt …';

      function drawerEl() { return document.querySelector('cart-drawer-component'); }
      function hasDrawer() { return !!drawerEl(); }
      function openDrawer() {
        var cd = drawerEl();
        var td = cd && cd.closest('theme-drawer');
        try { if (td && !td.isOpen && typeof td.open === 'function') td.open(); } catch (e) {}
      }
      function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
      function imgSrc(img) { return img ? (img.currentSrc || img.src || '') : ''; }

      // Cart-Token wie in Shopifys @shopify/events (liest denselben cart-Cookie).
      function cookieCartToken() {
        try {
          var m = document.cookie.match(/(?:^|;\s*)cart=([^;]*)/);
          return m ? decodeURIComponent(m[1]) : '';
        } catch (e) { return ''; }
      }
      // Warenkorb-JSON aus der Section-Antwort lesen und auf den Aufbau von /cart.js bringen
      // (token aus dem Cookie, discount_codes aus der Section). Ohne Token -> null -> /cart.js-Fallback,
      // damit das CartLinesUpdateEvent in jedem Fall identisch bleibt.
      function cartFromSections(sections) {
        try {
          var html = sections && sections[CART_JSON_SECTION];
          if (!html) return null;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('[data-alb-cart-json]');
          var cart = el ? JSON.parse(el.textContent) : null;
          if (!cart || typeof cart.item_count !== 'number' || !Array.isArray(cart.items)) return null;
          var token = cookieCartToken();
          if (!token) return null;
          cart.token = token;
          if (!Array.isArray(cart.discount_codes)) {
            var dc = doc.querySelector('[data-alb-cart-discount-codes]');
            var codes = dc ? JSON.parse(dc.textContent) : null;
            cart.discount_codes = Array.isArray(codes) ? codes : [];
          }
          return cart;
        } catch (e) { return null; }
      }
      function fetchCart() {
        return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
          .then(function (r) { return r.json(); });
      }

      // ---- Header-Badge (alb-header: #CartCount [data-cart-count]; Horizons cart-icon falls vorhanden) ----
      // Im Theme aktualisiert sonst nichts die Badge nach einem AJAX-Add – deshalb hier: sofort +Menge,
      // nach der Antwort der echte item_count, bei Fehler zurück auf den alten Wert.
      function badgeEls() { return Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')); }
      function readBadge() {
        var el = badgeEls()[0];
        return el ? (parseInt(el.textContent, 10) || 0) : null;
      }
      function setBadge(n) {
        badgeEls().forEach(function (el) {
          el.textContent = String(n);
          var bubble = el.closest('[data-cart-count-bubble]');
          if (bubble) bubble.classList.toggle('hide', n <= 0);
        });
        document.querySelectorAll('cart-icon').forEach(function (ic) {
          try { if (typeof ic.renderCartBubble === 'function') ic.renderCartBubble(n, false); } catch (e) {}
        });
      }

      // ---- Sofort-Rückmeldung ---------------------------------------------------------
      // Sichtbares Galeriebild (aktive Slide) für die Platzhalterzeile.
      function visibleGalleryImage(root) {
        var imgs = root.querySelectorAll('img.alb-mp-img');
        var best = null, bestArea = 0;
        for (var i = 0; i < imgs.length; i++) {
          var r = imgs[i].getBoundingClientRect();
          var w = Math.max(0, Math.min(r.right, window.innerWidth) - Math.max(r.left, 0));
          var h = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
          if (w * h > bestArea) { bestArea = w * h; best = imgs[i]; }
        }
        return best;
      }
      // ---- Geldbeträge im Format des Shops lesen/schreiben (z. B. "1.234,56 EUR") ----
      function parseMoney(str) {
        var t = String(str || '').trim();
        var m = t.match(/\d(?:[\d.,\s ]*\d)?/);   // Ziffernblock inkl. Tausender-/Dezimaltrenner
        if (!m) return null;
        var num = m[0], prefix = t.slice(0, m.index), suffix = t.slice(m.index + num.length);
        var intPart = num, frac = '', decimal = '', decimals = 0;
        var lastSep = Math.max(num.lastIndexOf(','), num.lastIndexOf('.'));
        if (lastSep > -1 && num.length - lastSep - 1 <= 2) {
          decimal = num.charAt(lastSep); frac = num.slice(lastSep + 1); intPart = num.slice(0, lastSep); decimals = frac.length;
        }
        var thousands = (intPart.match(/[.,\s ]/) || [''])[0];
        var cents = parseInt(intPart.replace(/\D/g, ''), 10) * 100 + (decimals ? parseInt((frac + '00').slice(0, 2), 10) : 0);
        if (isNaN(cents)) return null;
        return { cents: cents, prefix: prefix, suffix: suffix, thousands: thousands, decimal: decimal, decimals: decimals };
      }
      function formatMoney(cents, fmt) {
        var whole = String(Math.floor(cents / 100)), rest = cents % 100;
        if (fmt.thousands) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, fmt.thousands);
        if (fmt.decimals) whole += fmt.decimal + (rest < 10 ? '0' : '') + rest;
        return fmt.prefix + whole + fmt.suffix;
      }
      function linePrice(priceStr, qty) {
        if (!priceStr) return '';
        if (qty <= 1) return priceStr;
        var m = parseMoney(priceStr);
        return m ? formatMoney(m.cents * qty, m) : priceStr;
      }
      // Mehrere Positionen (Bundle-Permalink): meta.price ist dann der Gesamtpreis, nicht × Menge.
      function isMulti(meta) { return !!(meta && meta.items && meta.items.length > 1); }
      function pendingPrice(meta, qty) { return isMulti(meta) ? (meta.price || '') : linePrice(meta.price, qty); }
      function pendingText(meta, qty) {
        if (isMulti(meta)) return meta.items.length + ' Artikel · ' + PENDING_TEXT;
        return qty > 1 ? qty + ' × ' + PENDING_TEXT : PENDING_TEXT;
      }
      function sizedImage(url) {
        if (!url) return '';
        return url.indexOf('/cdn/shop/') > -1 ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : url;
      }

      // Titel/Variante/Bild/Preis aus dem Kontext des Formulars bzw. Links ableiten.
      function metaFor(src, button, formData) {
        var meta = { button: button || null, title: '', sub: '', image: '', price: '' };
        if (!(src instanceof Element)) return meta;
        var vid = formData ? String(formData.get('id') || '') : '';
        var plan = formData ? String(formData.get('selling_plan') || '') : '';
        var popRow = src.closest('.alb-mp-xa-pop-row');
        var card = src.closest('.alb-mp-xa-card');
        var row = src.closest('tr');
        if (popRow) {
          // Varianten-Popup hängt beim Öffnen am <body> (nicht mehr in der Karte): Titel aus dem
          // Popup-Kopf (Text vor dem <br>), sonst über den Öffner-Button zurück zur Karte.
          var pop = popRow.closest('.alb-mp-xa-pop');
          var head = pop ? pop.querySelector('.alb-mp-xa-pop-head span') : null;
          var first = head && head.firstChild && head.firstChild.nodeType === 3 ? head.firstChild.textContent : '';
          var opener = pop && pop.id ? document.querySelector('[data-xa-open][aria-controls="' + pop.id + '"]') : null;
          var popCard = opener ? opener.closest('.alb-mp-xa-card') : null;
          meta.title = (first || '').replace(/\s+/g, ' ').trim() || txt(popCard ? popCard.querySelector('.nm') : null);
          meta.sub = txt(popRow.querySelector('.alb-mp-xa-pop-t'));
          meta.image = imgSrc(popRow.querySelector('.alb-mp-xa-pop-img img'));
          meta.price = txt(popRow.querySelector('.alb-mp-xa-pop-p'));
        }
        if (card) {
          meta.title = txt(card.querySelector('.nm'));
          if (!meta.image) meta.image = imgSrc(card.querySelector('.thumb img'));
          if (!meta.price) {
            var pr = txt(card.querySelector('.pr'));
            if (pr && !/^ab\s/i.test(pr)) meta.price = pr;   // "ab …" = Varianten-Karte -> kein fester Preis
          }
        } else if (row) {
          meta.title = txt(row.querySelector('.alb-tab-c1')) || txt(row.querySelector('th'));
          meta.image = imgSrc(row.querySelector('img'));
        } else if (!popRow) {
          // Hauptformular (oder Sticky-Leiste) auf der Produktseite -> Daten des Hauptprodukts
          var mp = src.closest('.alb-mp') || document.querySelector('.alb-mp');
          if (mp) {
            meta.title = txt(mp.querySelector('.alb-mp-title'));
            var variant = null, prices = null;
            try {
              var vs = JSON.parse(mp.querySelector('[data-variants]').textContent);
              for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === vid) { variant = vs[i]; break; }
            } catch (e) {}
            try { prices = JSON.parse(mp.querySelector('[data-variant-prices]').textContent); } catch (e) {}
            if (variant && variant.title && variant.title !== 'Default Title') meta.sub = variant.title;
            var mediaId = variant && variant.featured_media ? variant.featured_media.id : null;
            var slideImg = mediaId ? mp.querySelector('.alb-mp-slide[data-media-id="' + mediaId + '"] img') : null;
            meta.image = imgSrc(slideImg)
              || sizedImage(variant && variant.featured_image ? variant.featured_image.src : '')
              || imgSrc(visibleGalleryImage(mp))
              || imgSrc(mp.querySelector('img.alb-mp-img'));
            if (plan) {
              meta.price = txt(mp.querySelector('[data-sub-price]')) || txt(mp.querySelector('[data-price-now]'));
            } else {
              meta.price = (prices && prices[vid]) || txt(mp.querySelector('[data-price-now]'));
            }
          }
        }
        if (src.dataset) {
          if (src.dataset.albTitle) meta.title = src.dataset.albTitle;
          if (src.dataset.albImage) meta.image = src.dataset.albImage;
          if (src.dataset.albPrice) meta.price = src.dataset.albPrice;
        }
        if (!meta.title) meta.title = 'Artikel';
        return meta;
      }
      var ICON_MINUS = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/></svg>';
      var ICON_PLUS = '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/><path d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/></svg>';
      function el(tag, cls, attrs) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (attrs) Object.keys(attrs).forEach(function (k) { e.setAttribute(k, attrs[k]); });
        return e;
      }
      // Variantenwerte wie Horizon: ein <dd> je Option, Komma nach allen außer der letzten.
      function variantValues(meta) {
        if (!meta.sub || isMulti(meta)) return [];
        return meta.sub.split(' / ').map(function (v) { return v.trim(); }).filter(Boolean);
      }
      // Platzhalterzeile = Aufbau der echten Drawer-Zeile (Klassen aus snippets/cart-products.liquid):
      // Bild, Titel, Varianten, Mengenwähler-Optik, Preis; statt Papierkorb ein Spinner. Kein Bedienelement aktiv.
      function buildPending(meta, qty) {
        var tr = el('tr', 'cart-items__table-row cart-items__table-row--full-width-variants alb-cart-pending', { role: 'row', 'aria-busy': 'true' });

        var media = el('td', 'cart-items__media', { role: 'cell' });
        var box = el('div', 'cart-items__media-container', { style: '--ratio:1;' });
        if (meta.image) {
          var img = el('img', 'cart-items__media-image border-style', { alt: '' });
          img.src = meta.image;
          box.appendChild(img);
        }
        media.appendChild(box);

        var details = el('td', 'cart-items__details cart-primary-typography', { role: 'cell' });
        var info = el('div', 'cart-items__product-info');
        var titleRow = el('div', 'cart-items__title-row');
        var title = el('span', 'cart-items__title');
        title.textContent = meta.title;
        titleRow.appendChild(title);
        info.appendChild(titleRow);
        var sr = el('span', 'visually-hidden');
        sr.textContent = pendingText(meta, qty);
        info.appendChild(sr);
        details.appendChild(info);
        var vw = el('div', 'cart-items__variants-wrapper');
        var values = variantValues(meta);
        if (values.length) {
          var dl = el('dl', 'cart-items__variants');
          values.forEach(function (v, i) {
            var dv = el('div', 'cart-items__variant');
            var dd = el('dd');
            dd.textContent = v + (i < values.length - 1 ? ', ' : '');
            dv.appendChild(dd);
            dl.appendChild(dv);
          });
          vw.appendChild(dl);
        }
        details.appendChild(vw);

        var qtd = el('td', 'cart-items__quantity', { role: 'cell' });
        var controls = el('div', 'cart-items__quantity-controls');
        var qwrap = el('div', 'quantity-selector-wrapper');
        var qs = el('div', 'quantity-selector cart-primary-typography', { 'aria-hidden': 'true' });
        var minus = el('button', 'button quantity-minus button-unstyled', { type: 'button', tabindex: '-1' });
        minus.innerHTML = '<span class="svg-wrapper icon-plus">' + ICON_MINUS + '</span>';
        var input = el('input', '', { type: 'number', value: String(qty), tabindex: '-1', readonly: '' });
        var plus = el('button', 'button quantity-plus button-unstyled', { type: 'button', tabindex: '-1' });
        plus.innerHTML = '<span class="svg-wrapper icon-plus">' + ICON_PLUS + '</span>';
        qs.appendChild(minus); qs.appendChild(input); qs.appendChild(plus);
        qwrap.appendChild(qs);
        var remove = el('button', 'button cart-items__remove', { type: 'button', tabindex: '-1', 'aria-hidden': 'true' });
        remove.innerHTML = '<span class="alb-cart-pending-spin" aria-hidden="true"></span>';
        controls.appendChild(qwrap);
        controls.appendChild(remove);
        qtd.appendChild(controls);

        var price = el('td', 'cart-items__price cart-secondary-typography', { role: 'cell' });
        var lineStr = pendingPrice(meta, qty);
        if (lineStr) {
          var tc = el('text-component', '', { value: lineStr });
          tc.textContent = lineStr;
          price.appendChild(tc);
        } else {
          price.appendChild(el('span', 'alb-cart-pending-bar', { 'aria-hidden': 'true' }));
        }

        tr.appendChild(media);
        tr.appendChild(details);
        tr.appendChild(qtd);
        tr.appendChild(price);
        return tr;
      }
      // Ladeblock für den leeren Drawer (dort gibt es keine Tabelle): Bild, Titel, Hinweis.
      function buildPendingEmpty(meta, qty) {
        var block = document.createElement('div');
        block.className = 'alb-cart-pending-empty';
        block.setAttribute('aria-busy', 'true');
        var fig = document.createElement('div');
        fig.className = 'alb-cart-pending-empty-img';
        if (meta.image) {
          var img = document.createElement('img');
          img.src = meta.image;
          img.alt = '';
          fig.appendChild(img);
        }
        block.appendChild(fig);
        var title = document.createElement('p');
        title.className = 'alb-cart-pending-empty-title';
        title.textContent = meta.title + (meta.sub ? ' · ' + meta.sub : '');
        block.appendChild(title);
        var lineStr = pendingPrice(meta, qty);
        if (lineStr) {
          var pr = document.createElement('p');
          pr.className = 'alb-cart-pending-empty-price';
          pr.textContent = lineStr;
          block.appendChild(pr);
        }
        var hint = document.createElement('p');
        hint.className = 'alb-cart-pending-hint';
        var spin = document.createElement('span');
        spin.className = 'alb-cart-pending-spin';
        spin.setAttribute('aria-hidden', 'true');
        hint.appendChild(spin);
        hint.appendChild(document.createTextNode(pendingText(meta, qty)));
        block.appendChild(hint);
        return block;
      }
      // Platzhalter oben in die Liste (neue Artikel stehen bei Shopify oben). Leerer Warenkorb: die
      // serverseitige Vorlage des gefüllten Drawers (template[data-alb-pending-drawer] aus cart-drawer.liquid)
      // aktivieren – Kopf mit Badge, Versandbanner, Tabelle mit Platzhalterzeile, Summe. Ohne Vorlage
      // (z. B. nach Leeren im laufenden Betrieb) bleibt der kompakte Ladeblock.
      function insertPending(meta, qty) {
        var comp = document.querySelector('cart-drawer-component cart-items-component') || document.querySelector('cart-items-component');
        if (!comp) return null;
        var tbody = comp.querySelector('.cart-items__table tbody');
        if (tbody) {
          var tr = buildPending(meta, qty);
          tbody.insertBefore(tr, tbody.firstChild);
          return { node: tr, comp: null, restore: null };
        }
        var tpl = comp.querySelector('template[data-alb-pending-drawer]');
        var inner = comp.closest('.cart-drawer__inner');
        if (tpl && tpl.content) {
          var frag = document.importNode(tpl.content, true);
          var newHeader = frag.querySelector('.theme-drawer__header');
          var oldHeader = inner ? inner.querySelector(':scope > .theme-drawer__header') : null;
          var backup = { html: comp.innerHTML, oldHeader: oldHeader, newHeader: newHeader, hadEmptyClass: !!(inner && inner.classList.contains('cart-drawer--empty')) };
          if (newHeader) {
            if (oldHeader && oldHeader.parentNode) oldHeader.parentNode.replaceChild(newHeader, oldHeader);
            else if (newHeader.parentNode) newHeader.parentNode.removeChild(newHeader);
          }
          comp.innerHTML = '';
          comp.appendChild(frag);
          if (inner) inner.classList.remove('cart-drawer--empty');
          var body2 = comp.querySelector('.cart-items__table tbody');
          var tr2 = buildPending(meta, qty);
          if (body2) body2.insertBefore(tr2, body2.firstChild);
          return {
            node: tr2,
            comp: null,
            restore: function () {
              comp.innerHTML = backup.html;
              if (backup.newHeader && backup.newHeader.parentNode && backup.oldHeader) backup.newHeader.parentNode.replaceChild(backup.oldHeader, backup.newHeader);
              if (inner && backup.hadEmptyClass) inner.classList.add('cart-drawer--empty');
            }
          };
        }
        var block = buildPendingEmpty(meta, qty);
        comp.insertBefore(block, comp.firstChild);
        comp.classList.add('alb-cart-adding');   // blendet „Dein Warenkorb ist leer" + Leer-Inhalt aus
        return { node: block, comp: comp, restore: null };
      }
      function startPending(meta, qty) {
        var button = meta.button || null, wasDisabled = false;
        function setBusy(on) {
          if (!button) return;
          if (on) {
            wasDisabled = !!button.disabled;
            button.classList.add('alb-atc-busy');
            button.setAttribute('aria-busy', 'true');
            if ('disabled' in button) button.disabled = true;
          } else {
            button.classList.remove('alb-atc-busy');
            button.removeAttribute('aria-busy');
            if ('disabled' in button) button.disabled = wasDisabled;
          }
        }
        setBusy(true);
        document.documentElement.classList.add('alb-cart-swap');
        var badgeBefore = readBadge();
        if (badgeBefore !== null) setBadge(badgeBefore + qty);
        // Platzhalter einsetzen (aktiviert beim leeren Warenkorb die Vorlage des gefüllten Drawers)
        var placed = null;
        try { placed = insertPending(meta, qty); } catch (e) { placed = null; }
        // Drawer-Kopf-Badge + „Geschätzter Gesamtbetrag" sofort mitziehen; Horizons Morph setzt danach die echten Werte.
        var drawer = document.querySelector('cart-drawer-component');
        var dBadge = drawer ? drawer.querySelector('.theme-drawer__badge') : null;
        var dBadgeBefore = dBadge ? dBadge.textContent : null;
        var dBadgeHidden = dBadge ? dBadge.classList.contains('visually-hidden') : false;
        if (dBadge) {
          dBadge.textContent = String((parseInt(dBadge.textContent, 10) || 0) + qty);
          dBadge.classList.remove('visually-hidden');
        }
        var totalEl = drawer ? drawer.querySelector('text-component[ref="cartTotal"]') : null;
        var totalBefore = totalEl ? totalEl.textContent : null;
        var totalValBefore = totalEl ? totalEl.getAttribute('value') : null;
        var unit = meta.price ? parseMoney(meta.price) : null;
        var tot = totalEl ? parseMoney(totalEl.textContent) : null;
        if (totalEl && unit && tot) {
          var sum = formatMoney(tot.cents + (isMulti(meta) ? unit.cents : unit.cents * qty), tot);
          totalEl.textContent = sum;
          totalEl.setAttribute('value', sum);
        }
        var ended = false;
        function isPlaceholder(node) {
          return !!node && (node.classList.contains('alb-cart-pending') || node.classList.contains('alb-cart-pending-empty'));
        }
        function cleanup(failed) {
          if (ended) return;
          ended = true;
          setBusy(false);
          if (failed) {
            if (badgeBefore !== null) setBadge(badgeBefore);
            if (placed && placed.restore) {
              placed.restore();   // leerer Warenkorb: Leerzustand komplett zurück
            } else {
              if (dBadge && dBadgeBefore !== null) {
                dBadge.textContent = dBadgeBefore;
                if (dBadgeHidden) dBadge.classList.add('visually-hidden');
              }
              if (totalEl && totalBefore !== null) {
                totalEl.textContent = totalBefore;
                if (totalValBefore !== null) totalEl.setAttribute('value', totalValBefore);
              }
            }
          }
          if (placed && !(failed && placed.restore)) {
            // Nur entfernen, wenn es noch unser Platzhalter ist – Horizons Morph kann das <tr> direkt
            // in die echte Zeile umgewandelt haben (dann steht dort bereits der Artikel).
            if (isPlaceholder(placed.node) && placed.node.parentNode) placed.node.parentNode.removeChild(placed.node);
            if (placed.comp) placed.comp.classList.remove('alb-cart-adding');
          }
          // Einblend-Animation der neuen Zeile bleibt noch kurz unterdrückt (Zeile steht ja schon da).
          setTimeout(function () { document.documentElement.classList.remove('alb-cart-swap'); }, 800);
        }
        return {
          fail: function () { cleanup(true); },
          done: function () {
            setBusy(false);
            var node = placed && placed.node;
            var comp = node && node.closest('cart-items-component');
            if (comp && isPlaceholder(node) && node.isConnected) {
              // Erst nach Horizons Morph aufräumen (Platzhalter bleibt bis die echte Zeile da ist).
              var mo = new MutationObserver(function () { mo.disconnect(); cleanup(false); });
              mo.observe(comp, { childList: true, subtree: true });
              setTimeout(function () { mo.disconnect(); cleanup(false); }, 2500);
            } else {
              cleanup(false);
            }
          }
        };
      }

      // ---- Add per AJAX + natives Event feuern; Promise wie in Horizons product-form.js. ----
      // payload: FormData eines /cart/add-Formulars ODER { items: [{ id, quantity }, …] } (mehrteilige
      // Permalinks, z. B. Bundle-CTA der Ad-Landingpages). meta.before: optionales Promise, das vor dem
      // Add abgewartet wird (Rabattcode setzen) – Platzhalter/Badges stehen trotzdem sofort.
      // INP: Beim Tipp nur den Button-Spinner zeigen. Bild suchen (misst Layout), Drawer öffnen,
      // Platzhalter bauen und die Anfrage starten erst nach dem nächsten Bild – sonst wartet der
      // Tipp auf alles zusammen (gemessen 77 ms davon 50 ms erzwungenes Layout, 29.10.2026).
      function nachDemZeichnen(fn) {
        var gelaufen = false;
        var los = function () { if (!gelaufen) { gelaufen = true; fn(); } };
        requestAnimationFrame(function () { setTimeout(los, 0); });
        setTimeout(los, 1000); // Rückfallnetz, falls kein Frame kommt (Tab im Hintergrund)
      }

      function addToCart(payload, meta) {
        meta = meta || {};
        // Cart-Items-Section-IDs + Cart-JSON mitschicken -> Drawer morpht direkt, kein /cart.js nötig.
        var ids = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset && el.dataset.sectionId) ids.push(el.dataset.sectionId);
        });
        ids.push(CART_JSON_SECTION);
        var isForm = typeof FormData !== 'undefined' && payload instanceof FormData;
        var items;
        if (isForm) {
          payload.set('sections', ids.join(','));
          items = [{ id: String(payload.get('id') || ''), quantity: Number(payload.get('quantity')) || 1 }];
        } else {
          items = (payload.items || []).map(function (i) { return { id: String(i.id), quantity: Number(i.quantity) || 1 }; });
        }
        if (items.length > 1) meta.items = items;
        var qty = items.reduce(function (n, i) { return n + i.quantity; }, 0) || 1;
        var deferred = CartLinesUpdateEvent.createPromise();

        document.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map(function (i) { return { merchandiseId: i.id, quantity: i.quantity }; }),
          promise: deferred.promise
        }));

        openDrawer();
        var pending = startPending(meta, qty);

        function finish(cart, added) {
          setBadge(cart.item_count);
          pending.done();
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              itemCount: cart.item_count,
              sections: added.sections,
              source: 'alb-cart',
              didError: false
            }
          });
          return true;
        }

        var request = isForm
          ? { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: payload, credentials: 'same-origin' }
          : { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items, sections: ids.join(',') }), credentials: 'same-origin' };
        var before = meta.before && typeof meta.before.then === 'function' ? meta.before.catch(function () {}) : Promise.resolve();

        return before
          .then(function () { return fetch(CART_ADD, request); })
          .then(function (r) { return r.json(); })
          .then(function (added) {
            if (added && added.status) { // Shopify-Fehler (z. B. ausverkauft)
              pending.fail();
              deferred.reject(new Error(added.description || added.message || 'add-to-cart failed'));
              return false;
            }
            var cart = cartFromSections(added && added.sections);
            if (cart) return finish(cart, added);
            return fetchCart().then(function (c) { return finish(c, added); }); // Fallback wie bisher
          })
          .catch(function (e) { pending.fail(); deferred.reject(e); return false; });
      }

      // 1) Eigene product-Forms (NICHT Horizons product-form-component -> die macht das selbst).
      document.addEventListener('submit', function (event) {
        var form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (action.indexOf('/cart/add') === -1) return;      // nur Warenkorb-Forms
        if (form.closest('product-form-component')) return;   // Horizons Forms -> nativ
        if (!hasDrawer()) return;                             // kein Drawer -> native /cart-Seite
        event.preventDefault();
        var button = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
        if (button && button.classList.contains('alb-atc-busy')) return; // läuft bereits
        var fd = new FormData(form); // Formularstand im Moment des Tipps
        if (button) button.classList.add('alb-atc-busy');
        nachDemZeichnen(function () {
          try {
            addToCart(fd, metaFor(form, button, fd)).then(function (ok) { if (!ok) form.submit(); });
          } catch (e) {
            if (button) button.classList.remove('alb-atc-busy');
            form.submit();
          }
        });
      }, true);

      // 2) Cart-Permalink-Links: /cart/<variantId>:<qty> oder mehrteilig /cart/<id>:<qty>,<id>:<qty>
      //    (alb-tabelle / alb-filter-info / Bundle-CTA der Ad-Landingpages). Ein ?discount=CODE wird
      //    vorher über /discount/CODE gesetzt. Platzhalter-Daten optional per data-alb-title/-image/-price.
      document.addEventListener('click', function (event) {
        var a = event.target instanceof Element ? event.target.closest('a[href*="/cart/"]') : null;
        if (!a) return;
        var url;
        try { url = new URL(a.href, window.location.origin); } catch (e) { return; }
        var m = url.pathname.match(/\/cart\/(\d+:\d+(?:,\d+:\d+)*)$/);
        if (!m) return;
        if (!hasDrawer()) return;
        event.preventDefault();
        if (a.classList.contains('alb-atc-busy')) return; // läuft bereits
        var items = m[1].split(',').map(function (part) {
          var q = part.split(':');
          return { id: q[0], quantity: Number(q[1]) || 1 };
        });
        a.classList.add('alb-atc-busy');
        nachDemZeichnen(function () {
          try {
            var meta = metaFor(a, a, null);
            var code = url.searchParams.get('discount');
            if (code) {
              meta.before = fetch('/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(CART_URL + '.js'), { credentials: 'same-origin' });
            }
            addToCart({ items: items }, meta).then(function (ok) { if (!ok) window.location.href = a.href; });
          } catch (e) {
            a.classList.remove('alb-atc-busy');
            window.location.href = a.href;
          }
        });
      }, true);
    })();
  }
